<template>
  <div>
    <div class="row form-group">
      <div class="col-md-12">
        <span class="badge badge-primary mb-2">
          {{ $t('homework.result') }}
        </span>
        <div
          ref="drop_zone"
          id="drop_zone"
          class="ts-p-3 ts-border ts-border-gray-300 ts-rounded ts-border-dashed overflow-auto"
          :class="{ 'ts-bg-blue-300': is_drag_over }"
          v-cloak
          @drop.prevent="addFile"
          @dragover.prevent="() => (is_drag_over = true)"
          @dragleave.prevent="() => (is_drag_over = false)"
          @dblclick="$refs.input_submit_file.click()"
        >
          <span v-if="files.list.length == 0">
            {{ $t('homework.dragDropHere') }}
          </span>
          <template v-for="(file, index) in files.list">
            <file-item
              :item="file"
              :key="index"
              :file-index="index"
              @remove="removeFile"
              @download="onDownload"
            />
          </template>
        </div>
        <input
          type="file"
          ref="input_submit_file"
          multiple
          @change="onClickFileChange"
          style="display:none"
        />
      </div>
    </div>
  </div>
</template>

<script>
import * as FileDownload from 'downloadjs'
import httpClient from '@/http-client'
import FileItem from './file-item'
import { mapActions } from 'vuex'

export default {
  name: 'drageDropUploadFile',
  props: ['value', 'student'],
  components: {
    FileItem
  },
  data() {
    return {
      files: {
        list: []
      },
      is_drag_over: false
    }
  },
  created() {
    this.files = this.value
  },
  methods: {
    ...mapActions('eschool/homeworkCorrection', ['removeFileUploaded']),
    onClickFileChange(e) {
      if (!this.student.student_homework_id) {
        this.$toasted.error('Please select student first...')
        this.$refs.input_submit_file.value = null
        return
      }
      let files = e.target.files
      this.files.list = [
        ...this.files.list,
        ..._.map(files, file => ({
          name: file.name,
          size: parseInt(file.size / 1024),
          type: file.type,
          progressing: 0,
          invalid_file: this.validate(file),
          file: file,
          uploaded: false,
          storage_path: null
        }))
      ]
      this.uploadFile()
    },
    addFile(e) {
      if (!this.student.student_homework_id) {
        this.$toasted.error('Please select student first...')
        this.is_drag_over = false
        return
      }
      let droppedFiles = e.dataTransfer.files
      if (!droppedFiles) return
      this.files.list = [
        ...this.files.list,
        ..._.map(droppedFiles, file => ({
          name: file.name,
          size: parseInt(file.size / 1024),
          type: file.type,
          progressing: 0,
          invalid_file: this.validate(file),
          file: file,
          uploaded: false,
          storage_path: null
        }))
      ]
      this.is_drag_over = false
      this.uploadFile()
    },
    removeFile({ index, record }) {
      record.progressing = 0
      let file_index = this.$parent.model.file_list.indexOf(
        ...this.$parent.model.file_list.filter(
          f => f.attach_file_path == record.storage_path
        )
      )
      this.$parent.model.file_list[index].is_delete = true
      this.files.list.splice(index, 1)
    },
    uploadFile() {
      _.forEach(
        this.files.list.filter(file => file.uploaded == false),
        (f, index) => {
          if (!this.validate(f.file)) {
            let frm = new FormData()
            frm.append('file', f.file)
            httpClient
              .post('/api/homework-upload/answer-sheet-files', frm, {
                onUploadProgress: el => {
                  if (el.lengthComputable) {
                    f.progressing = Math.round((el.loaded * 100) / el.total)
                  }
                }
              })
              .then(response => {
                f.uploaded = true
                f.storage_path = response.data.attach_file_path
                this.$parent.model.file_list.push(
                  Object.assign({}, response.data)
                )
              })
              .catch(error => {
                this.$toasted.error(error.message)
              })
          }
        }
      )
    },
    onDownload({ index, record }) {
      record.progressing = 0
      this.$store
        .dispatch('eschool/homeworkCorrection/download', {
          filePath: record.storage_path.split('filePath=').pop()
        })
        .then(response => {
          record.progressing = 100
          FileDownload(response, record.name, record.type)
        })
        .catch(error => {
          let parese_error = JSON.parse(
            String.fromCharCode.apply(null, new Uint8Array(error))
          )
          this.$toasted.error(parese_error.message)
        })
        .finally(() => {
          record.action = false
        })
    },
    validate(file) {
      let ALLOW_FILE = [
        'image/png',
        'image/jpeg',
        'application/pdf',
        'application/vnd.openxmlformats-officedocument.presentationml.presentation',
        'application/vnd.ms-powerpoint',
        'application/vnd.ms-excel',
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        'application/msword'
      ]

      if (file.size > 10000000 * 10 || !ALLOW_FILE.includes(file.type)) {
        return true
      }

      return false
    }
  }
}
</script>

<style lang="css" scoped>
#drop_zone {
  min-height: 100px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}
</style>
